const getScrollEndWidth = (navParams) => navParams?.current?.linkLeftPositions?.[0] * 2 || 0

const toggleChevronVisibility = (navParams, scrollPosition, hideChevron = true) => {
  const scrollEndWidth = getScrollEndWidth(navParams)
  return scrollPosition <= scrollEndWidth ? hideChevron : ''
}

const getLinkLeftPositions = (navRef) => {
  const offset = navRef?.current?.getBoundingClientRect()?.left

  if (navRef?.current?.children) {
    return Array.from(navRef?.current?.children).map((element) => {
      return element?.getBoundingClientRect().left - offset + navRef.current.scrollLeft
    })
  }

  return null
}

// Prioritise showing partially visible links in the next slide window
const getPartiallyVisibleLink = (prev, curr, scrollVector, direction, padding) => {
  const thereIsPartiallyVisibleLinkRight = prev < scrollVector && scrollVector < curr
  if (thereIsPartiallyVisibleLinkRight && direction === 'right') {
    if (!(curr - scrollVector < padding)) {
      return prev
    }
  }

  const tooFarLeft = curr < scrollVector
  if (tooFarLeft && direction === 'left') {
    return prev
  }
  return curr
}

const getNextViewLeft = (navRef, navParams, direction, isBrands) => {
  const chevronButtonWidth = isBrands ? 0 : 40
  const { scrollLeft } = navRef.current || {}
  const { offsetWidth } = navParams.current || {}
  const nextIntendedScrollPosition = direction === 'right' ? scrollLeft + offsetWidth : scrollLeft - offsetWidth
  const scrollEndWidth = getScrollEndWidth(navParams)

  // Approximate moving an entire frame with the left scroll position of the closest link
  return (
    navParams?.current?.linkLeftPositions?.reduce((prev, curr) => {
      return Math.abs(curr - nextIntendedScrollPosition) < Math.abs(prev - nextIntendedScrollPosition)
        ? getPartiallyVisibleLink(prev, curr, nextIntendedScrollPosition, direction, scrollEndWidth)
        : prev
    }) - chevronButtonWidth
  )
}

export { toggleChevronVisibility, getLinkLeftPositions, getPartiallyVisibleLink, getNextViewLeft }
